/**
 * @fileoverview Eurofarma Central Dashboard page component
 * Displays quick access buttons for Eurofarma Central operations team
 */

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { fetchData, intl, HTTP_STATUS } from "dmsbasereact";

import { DashboardLayout } from "../../components/Dashboard";
import { APP_ROUTES } from "../../utils/NamedRoutes";
import { APP_COLORS } from "../../theme/appTheme";

// MUI Icons
import PersonAddIcon from "@mui/icons-material/PersonAdd";

/**
 * EurofarmaCentralDashboard - Dashboard page for Eurofarma Central operations team
 * @returns {JSX.Element} The Eurofarma Central dashboard with quick access
 */
export const EurofarmaCentralDashboard = () => {
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState(null);

    /**
     * Fetch dashboard data from API
     */
    const fetchDashboardData = useCallback(async () => {
        setLoading(true);
        try {
            const statsResponse = await fetchData("/dashboard/eurofarma/stats", "GET", true);

            if (statsResponse.status === HTTP_STATUS.OK_200) {
                setStats(statsResponse.data?.data);
            }
        } catch (err) {
            console.error("Error fetching Eurofarma Central dashboard data:", err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchDashboardData();
    }, [fetchDashboardData]);

    // Quick access buttons configuration
    const quickAccessConfig = [
        {
            label: intl.get("Dashboard.Central.UserApproval").d("User Approval (Doctor/Pharmacist)"),
            icon: PersonAddIcon,
            route: APP_ROUTES.PendingAccountApprovals,
            color: APP_COLORS.primary.main,
        },
    ];

    return (
        <DashboardLayout
            welcomeName={stats?.user_name}
            loading={loading}
            stats={[]}
            quickAccess={quickAccessConfig}
            alerts={[]}
        />
    );
};
